import { bool, func, number, object } from 'prop-types'
import { useState } from 'react'
import { AnalyticsConsumer } from '@opallabs/quanta'
import { ContentContextMenu } from './ContentContextMenu'
import { DefaultContentListItem } from './Default'
import GhostContentListItem from './Ghost'
import './styles.scss'

const ContentListItem = ({
  content,
  contextMenuCallbacks,
  index,
  isLimitedUser,
  isMomentDragActive,
  moment,
  onDragRestrictedContent,
  story,
}) => {
  const [isRenamePopoverOpen, setIsRenamePopoverOpen] = useState(false)

  if (content && content.is_ghost) {
    return (
      <GhostContentListItem
        content={content}
        index={index}
        moment={moment}
        onDragRestrictedContent={onDragRestrictedContent}
      />
    )
  }

  if (content) {
    return (
      <AnalyticsConsumer>
        {({ track }) => (
          <ContentContextMenu
            contextMenuCallbacks={contextMenuCallbacks}
            content={content}
            setIsRenamePopoverOpen={setIsRenamePopoverOpen}
            moment={moment}
            track={track}
          >
            <DefaultContentListItem
              closeRenamePopover={() => setIsRenamePopoverOpen(false)}
              content={content}
              contextMenuCallbacks={contextMenuCallbacks}
              index={index}
              isLimitedUser={isLimitedUser}
              isMomentDragActive={isMomentDragActive}
              isPlaceholder={content.isPlaceholder}
              isRenamePopoverOpen={isRenamePopoverOpen}
              moment={moment}
              story={story}
            />
          </ContentContextMenu>
        )}
      </AnalyticsConsumer>
    )
  }

  return null
}

export default ContentListItem

ContentListItem.propTypes = {
  content: object,
  contextMenuCallbacks: object,
  index: number,
  isLimitedUser: bool,
  isMomentDragActive: bool,
  moment: object,
  onDragRestrictedContent: func,
  story: object,
}
